/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 510 510" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M454.24 94.64a15.574 15.574 0 00-.853-4.21c-.175-.51-.307-1.011-.533-1.498-.77-1.65-1.74-3.213-3.07-4.552-.008-.008-.012-.02-.023-.027l-79.676-79.68c-.008-.008-.02-.012-.031-.023-1.343-1.339-2.915-2.308-4.568-3.082-.463-.214-.946-.338-1.432-.51a15.723 15.723 0 00-4.335-.875c-.315-.02-.584-.183-.906-.183H135.688c-8.802 0-15.938 7.136-15.938 15.938v63.75H71.937c-8.8 0-15.937 7.136-15.937 15.937v398.438c0 8.8 7.136 15.937 15.938 15.937h286.875c8.8 0 15.937-7.136 15.937-15.938 0-8.8-7.136-15.937-15.938-15.937H87.875V111.562h31.875v318.75c0 8.802 7.136 15.938 15.938 15.938H438.5c8.801 0 15.938-7.136 15.938-15.938V95.625c0-.35-.176-.638-.199-.984zm-79.49-40.228l25.276 25.276H374.75V54.412zM151.625 414.375v-382.5h191.25v63.75c0 8.801 7.136 15.938 15.938 15.938h63.75v302.812H151.625z" />
      <path d="M358.813 207.188H215.375c-8.801 0-15.938-7.137-15.938-15.938 0-8.801 7.137-15.938 15.938-15.938h143.438c8.8 0 15.937 7.137 15.937 15.938 0 8.801-7.136 15.938-15.938 15.938zM358.813 270.938H215.375c-8.801 0-15.938-7.137-15.938-15.938 0-8.801 7.137-15.938 15.938-15.938h143.438c8.8 0 15.937 7.137 15.937 15.938 0 8.801-7.136 15.938-15.938 15.938zM358.813 334.688H215.375c-8.801 0-15.938-7.137-15.938-15.938 0-8.801 7.137-15.938 15.938-15.938h143.438c8.8 0 15.937 7.137 15.937 15.938 0 8.801-7.136 15.938-15.938 15.938z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconDuplicate = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconDuplicate.defaultProps = {
  theme,
};
IconDuplicate.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconDuplicate.displayName = 'IconDuplicate';
export { IconDuplicate };
